const getDecimalNumber = (value) => {
    if (value) {
        return Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
    } else {
        return ''
    }
}

export default getDecimalNumber
